import { useLocation } from 'react-router-dom';

import PlanningSession from '../../features/planning/layouts/planning';

// TSS vite/01 §"Pages are thin". /admin/planning (partos) · /admin/planning/dx (diagnósticos).
export default function PlanningPage() {
    const { pathname } = useLocation();
    const focus = pathname.endsWith('/dx') ? 'dx' : 'births';
    return <PlanningSession focus={focus} />;
}
